<template>
    <div>
         
      
        <mdb-row>
            <mdb-col md="4" style="margin-bottom: 10px;" id="personalSpouseMailbenef">
                <div class="form__group">
                    <label for="beneficairyEmail" class="form__label">Correo Electrónico:</label>
                    <input type="email" v-model="personalSpouseMail" id="beneficairyEmail" class="form__input"/>
                    <validation-error :validation="$v.personalSpouseMail" />
                </div>
            </mdb-col>
        </mdb-row>

        <mdb-row>
            <mdb-col md="4" style="margin-bottom: 10px;">
                <div class="form__group">
                    <label for="beneficaryPhone" class="form__label">Teléfono:</label>
                    <input type="text" id="beneficaryPhone" v-model="phone" class="form__input" placeholder="(+52) " value="" v-mask="'##########'" />
                    <validation-error :validation="$v.phone" />

                </div>
            </mdb-col>
        </mdb-row>

 
        <mdb-row>
            <mdb-col md="4" style="margin-bottom: 10px;">
                <div class="form__group">
                    <label for="benficaryOtherPhoneType" class="form__label">Otro Teléfono:</label>
                    <select v-model="phoneType" class="browser-default custom-select">
                        <option>Selecciona una opción</option>
                        <option value="Casa">Casa</option>
                        <option value="Oficina">Oficina</option>
                        <option value="OtherCelular">Celular</option>
                    </select>
                    <validation-error :validation="$v.phoneType" />

                </div>
            </mdb-col>
            <mdb-col md="4" style="margin-bottom: 10px;">
                <div class="form__group">
                     <div class="form__group">
                        <label for="benefiaryOtherPhoneNumber" class="form__label">Número:</label>
                        <input v-model="otherPhone" type="text" id="benefiaryOtherPhoneNumber" class="form__input" value="" v-mask="'##########'" />
                     </div>
                    <validation-error :validation="$v.otherPhone" />

                </div>
            </mdb-col>

      
        </mdb-row>

        
 

 
    </div>
</template>
<script>
    import Btn from '../../core/Button';
    import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
    import { mapGetters, mapMutations } from "vuex";
    import ValidationError from "../misc/ValidationError";
    import { required, email, minLength, alphaNum, maxLength, sameAs } from "vuelidate/lib/validators";
    import { mask } from "vue-the-mask";


    export default {
        name: "SpouseContactData",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            Btn,
            ValidationError,
        },
        directives: {mask},
        created(){
            this.userAllData = JSON.parse(localStorage.getItem("userAllData"));
            //console.log("SpouseAllData", this.userAllData );
            
            if(this.userAllData.beneficiaries != null){
					
                    
                    // 1.- DETECTAMOS EL TIPO DE  BENEFIACIARIO (SPOUSE
					let beneficiary = this.userAllData.beneficiaries;
					for (let i = 0; i < beneficiary.length; i++){
						if(beneficiary[i].beneficiaryType == "SPOUSE"){
                            let spouseINFO  = beneficiary[i];
                            //console.log("spouseINFO", spouseINFO);


                            //1.- Datos del Email para la esposa
                            if(spouseINFO.personalMail != null || spouseINFO.personalMail != undefined){
                                this.personalSpouseMail = spouseINFO.personalMail;
                            } 

                            //2.- Telefonos de la Esposa:
                            if(spouseINFO.phones.length > 0){

                                let phones = spouseINFO.phones;
                                // 1.- DETECTAMOS EL TIPO DE TELEFONO
                                    for (let i = 0; i < phones.length; i++){
                                        //console.log("phoneType --> ", phones[i].phoneType );
                                        
                                        // 1.- Para el celular de usuario 
                                        if(phones[i].phoneType == "Celular"){ 
                                            this.phone = phones[i].phoneNumber 
                                        }

                                        // 2.- Para el otro Tipo de Celular
                                        if(phones[i].phoneType == "Casa"){
                                            this.phoneType = "Casa"
                                            this.otherPhone = phones[i].phoneNumber
                                            //console.log("XXX casa");
                                        }

                                        if(phones[i].phoneType == "Oficina"){
                                            this.phoneType = "Oficina";
                                            this.otherPhone = phones[i].phoneNumber

                                        }

                                        if(phones[i].phoneType == "OtherCelular"){
                                            this.phoneType = "OtherCelular"
                                            this.otherPhone = phones[i].phoneNumber
                                        }


                                    }


                            } // if spouseINFO.phones
                            

                        }
                    }
            }




        },

        data(){
            return {
                infoIdIcon: 'info-default.svg',
                userAllData:"",
                infoIdIcon: 'info-default.svg',
                arrayPhones:[],
                phone:"",
                otherPhone:"",
                phoneType:"",
                contactName:"",
                contactRelationship:"",
                personalSpouseMail:"",
            }
        },
         validations: {
			personalSpouseMail: {
				email, 
				required
			},
            otherPhone: {
                required
            },
            
            phoneType:{
                required
            },
            
            phone: {
                required
            },


		},
        computed: {
            ...mapGetters({
                benefName: "getBeneficiaryName"
            }),
            beneficiaryName: {
                get(){
                    return this.benefName;
                },
                set(value){
                    this.$store.commit("_setName", value);
                }
            }
        },
        methods: {
            chooseFile(){
                document.getElementById("fileUpload").click();
            },
            chooseFileCurp(){
                document.getElementById("fileUploadCurp").click();
            },
            chooseFileColonia(){
                document.getElementById("fileUploadColonia").click();
            },
            chooseFileCartaAntec(){
                document.getElementById("fileUploadCartaAntec").click();
            },
            chooseFileIdentificacion(){
                document.getElementById("fileUploadIdentificacion").click();
            },
            mouseOverIcon(){
                let infoIdIcon = this.infoIdIcon.split("-");
                this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
            },
            mouseLeaveIcon(){
                let infoIdIcon = this.infoIdIcon.split("-");
                this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
            },

             getFormdata(){
                
                // validations 
                this.$v.$touch();
 


                if( this.$v.personalSpouseMail.email && 
                    this.$v.personalSpouseMail.required && 
                    this.$v.otherPhone.required &&
                    this.$v.phoneType.required &&
                    this.$v.phone.required 
                     ){
                    //console.log("fullContacSpouseData: ");

                    
                    var fullContacData = [{"phones": []}, {"email": ""}]; 

                    // 1.- phones
                    if(this.phone != ""){
                        fullContacData[0].phones.push({
                            phone: this.phone, 
                            phoneType:"Celular",
                            contactName:"",
                            contactRelationship:""
                        });
                    }

                    if(this.otherPhone != ""){
                         fullContacData[0].phones.push({
                            phone:this.otherPhone, 
                            phoneType:this.phoneType,
                            contactName:"",
                            contactRelationship:""
                        });
                    }
                    
                    // 1.- email
                    fullContacData[1].email = this.personalSpouseMail;

                    //console.log("fullContacSpouseData: ", fullContacData);
                    return fullContacData;

                }
                
                else{

                    /* window.scroll(0,0);
                     this.$notify.error({
                        message: "Los campos son requeridos",
                        position: "top right",
                        timeOut: 5000
                    }); */

                    return false;
                }

            },

        }
    }
</script>
<style>
    .t1-input-colonia {
        /* max-width: 80%; */
        display: inline;
        transform: translateY(3px);
        margin-bottom: 10px !important; 
    }

    .t1-input-curp {
        display: inline; 
        max-width: 70%; 
        transform: translateY(3px);
    }
    
    .t1-input-dia,
    .t1-input-mes {
        text-align: center;
        display: inline; 
        width: 8%; 
        margin-right: 15px; 
        transform: translateY(3px);
    }

    .t1-input-ano {
        text-align: center; 
        display: inline; 
        width: 12%; 
        transform: translateY(3px);
    }

    .btn-comprobante-domicilio {
        /* margin-left: 10px; */
        display: inline;
    }

    .btn-acta-nacimiento {
        display: inline-block; 
        margin-left: 10px;
    }

    .btn-upload-curp {
        display: inline; 
        margin-left: 10px;
    }

    .info-icon {
        width: 2rem;
        height: 2rem;
        margin-left: 1rem;
        transition: transform .2s;
    }

    .info-icon:hover {
        transform:  scale(1.3);
    }

    @media(max-width: 1199px){
        .t1-input-curp {
            display: block; 
            max-width: 100%; 
            transform: translateY(3px);
        }

        .t1-input-dia,
        .t1-input-mes {
            width: 12%; 
        }


        .t1-input-ano {
            width: 18%; 
        }

        .btn-upload-curp {
            display: block; 
            margin-top: 10px;
            margin-left: 0px;
        }

        .btn-acta-nacimiento {
            display: block; 
            margin-left: 0px;
            margin-top: 10px;
        }
    }

    @media(max-width: 992px){
        .btn-comprobante-domicilio {
            margin-left: 0px;
            display: block;
        }

        .t1-input-dia,
        .t1-input-mes {
            width: 18%; 
        }


        .t1-input-ano {
            width: 28%; 
        }
        

        .t1-input-colonia {
            max-width: 100%;
            margin-bottom: 10px;
            display: block;
        }   
    }

    @media(max-width: 768px){
        .t1-input-colonia {
            max-width: 100%;
        }
    }

    @media (max-width: 576px) { 
        
     }
</style>